/**
 * DSD 워크북 - IXD 값 채우기 통합 안내.
 *
 * 이 기능은 IXD 값 편집기 안으로 들어갔다. 메뉴는 그대로 두되 **이동하지 않고**
 * 통합 사실만 알리고, 유저가 버튼을 누를 때만 편집기로 보낸다.
 */

import { useNavigate } from "react-router-dom";

import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { existsModal, popModal, pushModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";

const MODAL_ID = "ixd-workbook-match-integration-guide";

export const IntegrationGuideModal = () => {
  const navigate = useNavigate();

  const goToEditor = () => {
    popModal();
    navigate("/ixd-editor");
  };

  // 껍데기(폭·패딩·타이포)는 오클릭 방지 팝업(misclick-confirm-modal)과 같다
  return (
    <ModalWrapper className="flex w-[458px] flex-col gap-0 rounded-[8px] border border-line-normal bg-white p-0 shadow-xxlarge">
      <h2 className="px-6 pt-5 label-1-normal-semibold text-label-normal break-keep">
        해당 기능은 IXD 값 편집기 화면으로 통합되었습니다
      </h2>
      <p className="px-6 py-4 label-2-medium text-label-alternative break-keep">
        앞으로는 IXD 값 편집기에서 IXD 파일을 열고 상단의 &lsquo;워크북 값
        불러오기&rsquo;를 누르면, 워크북에서 태깅한 DSD 값을 그대로 옮길 수
        있습니다.
      </p>
      <div className="flex justify-end gap-2 px-6 pb-5">
        <Button variant="outlined" size={36} onClick={popModal}>
          닫기
        </Button>
        {/* 편집기 쪽 CTA 는 전부 blue(Primary/Color) 다 — 안내도 같은 색으로 */}
        <Button variant="solid" color="blue" size={36} onClick={goToEditor}>
          IXD 값 편집기에서 작업하러 가기
        </Button>
      </div>
    </ModalWrapper>
  );
};

/**
 * 메뉴를 누를 때마다 띄운다 — 횟수 제한 없음(통합 사실은 매번 알린다).
 * 사이드바 두 곳이 같은 안내를 쓰고, 스택 push 는 id 가 같아도 그냥 쌓으므로
 * 이미 떠 있으면 거른다 — 같은 모달이 두 장 겹치지 않게.
 */
export const pushIntegrationGuideModal = () => {
  if (existsModal(MODAL_ID)) return;
  pushModal(IntegrationGuideModal, { id: MODAL_ID });
};
